import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import InlineList from 'components/InlineList';
import FormField, { useFormFieldContext } from 'components/FormField';
import BadgeImage from 'components/BadgeImage';
import BadgeImagePickerModal from 'screens/BadgeImagePickerModal';
import AddOrEditButton from './utils/AddOrEditButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BadgeField = function BadgeField(_ref) {
  var _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? true : _ref$horizontal,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    badge = _ref.badge,
    _onChange = _ref.onChange,
    parentPlaylistId = _ref.parentPlaylistId,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBadgeImageEditorOpen = _useState2[0],
    setBadgeImageEditorOpen = _useState2[1];
  var hasBadge = !!(badge && !badge.isDeleted && badge.imageId);
  return /*#__PURE__*/_jsxs(FormField, {
    as: "span",
    label: t('content_type_badge'),
    labelId: uniqueId,
    horizontal: horizontal,
    children: [/*#__PURE__*/_jsxs(InlineList, {
      spacing: "xxs",
      "aria-labelledby": labelId,
      align: "middle",
      children: [hasBadge && badge.pictureUrl && /*#__PURE__*/_jsx(BadgeImage, {
        src: badge === null || badge === void 0 ? void 0 : badge.pictureUrl,
        alt: badge === null || badge === void 0 ? void 0 : badge.imageAlternativeText,
        variant: badge === null || badge === void 0 ? void 0 : badge.style
      }), /*#__PURE__*/_jsx(AddOrEditButton, {
        isEditMode: hasBadge,
        addText: t('actions_add_badge'),
        editText: t('actions_edit_badge'),
        variant: variant,
        onClick: function onClick() {
          return setBadgeImageEditorOpen(true);
        },
        isDisabled: isDisabled
      })]
    }), isBadgeImageEditorOpen && /*#__PURE__*/_jsx(BadgeImagePickerModal, {
      parentPlaylistId: parentPlaylistId,
      initialSelectedBadgeImage: hasBadge && badge.imageId ? {
        imageId: Number(badge === null || badge === void 0 ? void 0 : badge.imageId),
        style: badge === null || badge === void 0 ? void 0 : badge.style,
        imageAlternativeText: badge === null || badge === void 0 ? void 0 : badge.imageAlternativeText,
        pictureUrl: badge === null || badge === void 0 ? void 0 : badge.pictureUrl
      } : null,
      onChange: function onChange(badgeImageChanges) {
        if (badgeImageChanges === null) {
          // A badge was deleted
          if (badge !== null && badge !== void 0 && badge.id) {
            _onChange({
              id: badge.id,
              imageId: null
            });
          }
          // Otherwise the badge was first selected, then unselected again
          else {
            _onChange(undefined);
          }
        } else {
          // A badge was added or edited
          _onChange(_objectSpread(_objectSpread(_objectSpread({}, badge), badgeImageChanges), {}, {
            isDeleted: false
          }));
        }
      },
      onClose: function onClose() {
        return setBadgeImageEditorOpen(false);
      }
    })]
  });
};
export default BadgeField;